import { useCallback, useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { RHEA_URL } from "@/lib/links";

const RHEA_AVATAR = "https://cdn.jotfor.ms/assets/agent-avatars/avatar_icon_79.png";

export default function RheaChat() {
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);
  const openAgent = useCallback(() => setOpen(true), []);

  useEffect(() => {
    setMounted(true);
    window.addEventListener("open-rhea-agent", openAgent);
    return () => window.removeEventListener("open-rhea-agent", openAgent);
  }, [openAgent]);

  if (!mounted) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid="rhea-chat-launcher"
          aria-label="Open Rhea Integrated Optimization Agent"
          className="fixed z-40 bottom-24 md:bottom-6 right-4 md:right-6 h-14 md:h-16 rounded-full bg-primary text-white border-2 border-accent/60 shadow-xl flex items-center gap-3 p-1.5 md:pr-5 hover:scale-[1.03] transition-transform"
        >
          <img src={RHEA_AVATAR} alt="" data-testid="rhea-chat-launcher-avatar" className="h-11 w-11 md:h-12 md:w-12 rounded-full object-cover bg-white" />
          <span className="hidden md:block font-mono text-xs uppercase tracking-[0.12em]">Ask Rhea</span>
        </button>
      </DialogTrigger>

      <DialogContent
        data-testid="rhea-chat-dialog"
        closeTestId="rhea-chat-close"
        closeClassName="text-white data-[state=open]:text-white"
        className="flex flex-col w-[calc(100vw-1rem)] max-w-[460px] h-[min(760px,calc(100dvh-1rem))] p-0 gap-0 overflow-hidden border-2 border-primary bg-background rounded-none"
      >
        <DialogHeader className="shrink-0 flex-row items-center gap-3 border-b border-border bg-primary px-4 py-3 pr-12 text-left space-y-0">
          <img src={RHEA_AVATAR} alt="" data-testid="rhea-chat-header-avatar" className="h-10 w-10 rounded-full object-cover bg-white" />
          <div className="min-w-0">
            <DialogTitle className="font-display text-base font-bold text-white">Rhea</DialogTitle>
            <DialogDescription className="mt-1 font-mono text-xs uppercase tracking-[0.08em] text-white/65">
              Integrated Optimization Agent
            </DialogDescription>
          </div>
        </DialogHeader>

        <div className="min-h-0 flex-1 bg-background">
          {open && (
            <iframe
              title="Rhea Integrated Optimization Agent conversation"
              src={RHEA_URL}
              data-testid="rhea-chat-iframe"
              className="h-full w-full border-0"
              loading="eager"
              referrerPolicy="strict-origin-when-cross-origin"
              allow="fullscreen"
              sandbox="allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-scripts allow-same-origin"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}